import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient.ts';
import { useTutorSession } from '../context/TutorSessionContext.tsx';

export function useEffectiveStudentId() {
  const { tutorSession } = useTutorSession();
  const [studentId, setStudentId] = useState<string | null>(tutorSession?.studentUserId ?? null);
  const [loading, setLoading] = useState<boolean>(!tutorSession);

  useEffect(() => {
    let cancelled = false;
    if (tutorSession?.studentUserId) {
      setStudentId(tutorSession.studentUserId);
      setLoading(false);
      return;
    }
    (async () => {
      setLoading(true);
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        if (!cancelled) {
          setStudentId(null);
          setLoading(false);
        }
        return;
      }
      const { data: student } = await supabase
        .from('students')
        .select('id')
        .eq('user_id', user.id)
        .maybeSingle();
      if (!cancelled) {
        setStudentId(student?.id ?? null);
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [tutorSession?.studentUserId]);

  return { studentId, loading };
}
